export const createFeedCommentPayload = ({ userId, feedId, comment }) => {
  if (!Number.isInteger(Number(userId)) || Number(userId) <= 0) throw new Error("Please sign in before replying.");
  if (!Number.isInteger(Number(feedId)) || Number(feedId) <= 0) throw new Error("Please select a valid post.");
  if (!comment?.trim()) throw new Error("Please write a reply.");
  return { user_id: Number(userId), feed_id: Number(feedId), comment: comment.trim() };
};

const commentTime = (createdAt) => {
  const date = new Date(createdAt);
  if (!Number.isFinite(date.getTime())) return "";
  const minutes = Math.max(0, Math.floor((Date.now() - date.getTime()) / 60000));
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes} min${minutes === 1 ? "" : "s"} ago`;
  const hours = Math.floor(minutes / 60);
  return hours < 24 ? `${hours} hour${hours === 1 ? "" : "s"} ago` : date.toLocaleDateString();
};

export const mergeFetchedComments = (fetched, current, initialIds) => {
  const unique = new Map(fetched.map((comment) => [comment.id, comment]));
  current.forEach((comment) => {
    if (!initialIds.has(comment.id) && !unique.has(comment.id)) unique.set(comment.id, comment);
  });
  return Array.from(unique.values());
};

export const normalizeFeedComment = (comment) => ({
  id: String(comment.id), userId: comment.user_id, feedId: String(comment.feed_id),
  author: comment.user_name || "Pack member", text: comment.comment,
  avatar: Array.isArray(comment.user_profile_image) ? comment.user_profile_image.find(Boolean) : comment.user_profile_image,
  createdAt: comment.created_at, updatedAt: comment.updated_at, time: commentTime(comment.created_at),
});
